import React, { useEffect, useState } from "react";
import "./style.css";
import CustomCard from "../../../../../dentail-indetifcation/components/d-reusable/CustomCard";
import { Col, Radio, Row } from "antd";
import { getExamMethods } from "../../../../../components/https/age-assessment-apis";
import {
  ageAssessmentBasePath,
  errorRequestHandel,
} from "../../../../../helper";
import CustomSpinner from "../../../../../dentail-indetifcation/components/d-reusable/CustomSpiner";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { _onSetExamMethods } from "../../../../../redux/actions/age-assessment/caseRegistrationAction";
import { useSubscriptionGuard } from "../../../../../hooks/subscription-hook/UseSubscriptionGuard";

const AgeGroup = () => {
  useSubscriptionGuard();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [methods, setMethods] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedMethod, setSelectedMethod] = useState("");
  useEffect(() => {
    getAllMethodsForExam();
  }, []);

  const getAllMethodsForExam = async () => {
    try {
      setLoading(true);
      const response = await getExamMethods();
      if (response.status === 200) {
        setMethods(response.data.data);
        setLoading(false);
      }
    } catch (error) {
      errorRequestHandel({ error: error });
      setLoading(false);
    }
  };

  const structuredAdults = methods.find((m) => m.id === 4)
    ? [
        {
          id: 4,
          title: "Radiographic Tooth Analysis",
          age_group: "R1",
          methods: methods
            .find((m) => m.id === 4)
            ?.methods.filter((method) =>
              ["cameriere_ferranto", "ikeda_drusini", "kvaal_solheim"].includes(
                method.slug
              )
            ),
        },
        {
          id: 5,
          title: "Intact Tooth Analysis",
          age_group: "R2",

          methods: methods
            .find((m) => m.id === 4)
            ?.methods.filter((method) =>
              ["lamendin", "bang"].includes(method.slug)
            )
            .concat([
              {
                id: 22,
                title: "Collation",
                slug: "collation",
                method_number: 90,
              },
            ]),
        },
        {
          id: 6,
          title: "Sectioned Tooth Analysis",
          age_group: "R3",

          methods: methods
            .find((m) => m.id === 4)
            ?.methods.filter((method) =>
              ["johanson_gustafson", "gustafson_maples"].includes(method.slug)
            )
            .concat([
              {
                id: 23,
                title: "Collation",
                slug: "collation",
                method_number: 91,
              },
            ]),
        },
      ]
    : [];

  const subAdults = methods.filter((m) => m.id !== 4);

  const groupedData = [
    {
      data: [...subAdults, ...structuredAdults],
    },
  ];

  const order = [1, 4, 2, 5, 3, 6];
  const methodDescriptions = {
    schour_massler: "Based on primary teeth development",
    schour_ubelaker: "Based on primary teeth development",
    collation_b: "Multi-methods primary teeth assessment",
    cameriere_ferranto: "Based on degenerative tooth structure",
    ikeda_drusini: "Based on degenerative tooth structure",
    kvaal_solheim: "Based on degenerative tooth structure",
    demirjian_willems: "Based on permanent teeth development",
    haavikko: "Based on permanent teeth development",
    bedek: "Based on permanent teeth development",
    collation_5: "Multi-methods permanent teeth assessment",
    lamendin: "Based on tooth feature changes  ",
    bang: "Based on tooth feature changes",
    collation_90: "Multi-methods intact tooth assessment",
    kohler_mesotte: "Based on wisdom teeth development",
    demirjian_mincer: "Based on wisdom teeth development",
    solari: "Based on wisdom teeth development",
    collation_ad: "Multi-methods wisdom teeth assessment",
    johanson_gustafson: "Based on section tooth morphology",
    gustafson_maples: "Based on section tooth morphology",
    collation_91: "Multi-methods section tooth assessment",
    // Add more as needed
  };

  const reorderedGroupedData = groupedData.map((group) => ({
    ...group,
    data: order
      .map((id) => group.data.find((item) => item.id === id))
      .filter(Boolean)
      .map((item) => ({
        ...item,
        methods:
          item.methods?.map((method) => {
            const key =
              method.slug === "collation" && method.method_number
                ? `collation_${method.method_number}`
                : method.slug;

            return {
              ...method,
              description: methodDescriptions[key] || "",
            };
          }) || [],
      })),
  }));

  const renderGroupTitle = (age_group) => {
    if (age_group === "B-4") {
      return "Primary Teeth Staging (Children)";
    } else if (age_group === "5-14") {
      return "Permanent Teeth Staging (Juvenile)";
    } else if (age_group === "15-21") {
      return "Wisdom Teeth Staging (Adolescent)";
    } else if (age_group === "R1") {
      return "Radiographic Tooth Analysis (Adult)";
    } else if (age_group === "R2") {
      return "Intact Tooth Analysis (Adult)";
    } else if (age_group === "R3") {
      return "Sectioned Tooth Analysis (Adult)";
    }
  };

  const handleExamMethod = (method, group) => {
    dispatch(_onSetExamMethods(method?.methods));
    setSelectedMethod((prev) =>
      group.title === "Adults" ? `adult-${method.id}` : `subadult-${method.id}`
    );
    if (method.age_group === "B-4") {
      navigate(`${ageAssessmentBasePath}/cases/age-group/sub-adult/primary`);
    } else if (method.age_group === "5-14") {
      navigate(`${ageAssessmentBasePath}/cases/age-group/sub-adult/permanent`);
    } else if (method.age_group === "15-21") {
      navigate(`${ageAssessmentBasePath}/cases/age-group/sub-adult/wisdome`);
    } else if (method?.age_group === "R1") {
      navigate(
        `${ageAssessmentBasePath}/cases/age-group/adults/radiographic-tooth-analysis`
      );
    } else if (method?.age_group === "R2") {
      navigate(
        `${ageAssessmentBasePath}/cases/age-group/adults/intact-tooth-analysis`
      );
    } else if (method?.age_group === "R3") {
      navigate(
        `${ageAssessmentBasePath}/cases/age-group/adults/sectioned-tooth-analysis`
      );
    } else return;
  };
  return (
    <CustomCard>
      <CustomSpinner loading={loading} />
      <div className="age_group_container">
        <div className="age_group_body">
          <p className="_heading">
            Select the age group and the corresponding method to start the age
            assessment process
          </p>
          {reorderedGroupedData.map((group, groupIndex) => (
            <div className="age_groups" key={groupIndex}>
              <br />
              <p>{group.title}</p>
              <br />
              <Row gutter={[16, 16]}>
                {group.data.map((method, index) => (
                  <Col md={12} key={index}>
                    <div
                      className="age_group_section"
                      onClick={() => handleExamMethod(method, group)}
                    >
                      <div className="age_group_section_top">
                        <h6>{renderGroupTitle(method.age_group)}</h6>
                        <Radio
                          name="age_group"
                          checked={selectedMethod === method.id}
                        />
                      </div>
                      <div className="age_group_section_bottom">
                        {method.methods.map((subMethod, subIndex) => (
                          <span key={subIndex}>{subMethod.title}</span>
                        ))}
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
          ))}
        </div>
      </div>
    </CustomCard>
  );
};

export default AgeGroup;
